/* ------------------------------------------------------------------
   Eos Hour widgets: quiz modal ("Find your perfect case") + the
   "Ask Eos Hour" floating assistant. Ported from the prototype
   (quiz ranking + askAnswer regex FAQ engine). Vanilla JS, no deps.
------------------------------------------------------------------ */
(function () {
  'use strict';

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
      (cents || 0) / 100
    );
  }
  function trapFocus(container, event) {
    var focusables = qsa('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container).filter(
      function (el) {
        return !el.disabled && el.offsetParent !== null;
      }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------------- Quiz ---------------- */
  var quiz = qs('[data-eos-quiz]');
  if (quiz) {
    var quizDataEl = qs('script[data-eos-quiz-data]');
    var catalog = [];
    if (quizDataEl) {
      try {
        catalog = JSON.parse(quizDataEl.textContent) || [];
      } catch (e) {
        catalog = [];
      }
    }
    var quizAnswers = [];
    var quizStep = 0;
    var quizReturnFocus = null;
    var panel = qs('[data-eos-quiz] .eos-quiz__panel', document) || quiz;
    var steps = qsa('[data-eos-quiz-step]', quiz);
    var resultsEl = qs('[data-eos-quiz-results]', quiz);
    var resultGrid = qs('[data-eos-quiz-result-grid]', quiz);
    var progressBars = qsa('[data-eos-quiz-progress] i', quiz);

    function setQuizLabel(id) {
      panel.setAttribute('aria-labelledby', id);
    }
    function resetQuiz() {
      quizAnswers = [];
      quizStep = 0;
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === 0);
      });
      if (resultsEl) resultsEl.classList.remove('is-active');
      progressBars.forEach(function (b, j) {
        b.classList.toggle('done', j === 0);
      });
      setQuizLabel('eosQuizTitle0');
    }
    function openQuiz() {
      // Close any open header menus first (mobile <details> menu).
      qsa('details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      quizReturnFocus = document.activeElement;
      resetQuiz();
      quiz.classList.add('open');
      quiz.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      var first = qs('.eos-quiz__step.is-active .eos-quiz__option', quiz);
      if (first) first.focus();
    }
    function closeQuiz() {
      if (!quiz.classList.contains('open')) return;
      quiz.classList.remove('open');
      quiz.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      if (quizReturnFocus && document.contains(quizReturnFocus)) quizReturnFocus.focus();
      quizReturnFocus = null;
    }
    function countFit(p, count) {
      if (count === '1') return !!p.fit1;
      if (count === '2-3') return !!p.fit23;
      return !!p.fit4p;
    }
    function showQuizResults() {
      var count = quizAnswers[0];
      var purpose = quizAnswers[1];
      var style = quizAnswers[2];
      var purposeMatches = catalog.filter(function (p) {
        return p.cats && p.cats.indexOf(purpose) !== -1;
      });
      var ranked = purposeMatches.slice().sort(function (a, b) {
        return (b.finish === style) - (a.finish === style) ||
          Number(countFit(b, count)) - Number(countFit(a, count));
      });
      var chosen = ranked.slice(0, 3);
      if (chosen.length < 3) {
        catalog
          .filter(function (p) {
            return p.finish === style && chosen.indexOf(p) === -1;
          })
          .sort(function (a, b) {
            return Number(countFit(b, count)) - Number(countFit(a, count));
          })
          .forEach(function (p) {
            if (chosen.length < 3) chosen.push(p);
          });
      }
      if (resultGrid) {
        resultGrid.innerHTML = chosen
          .map(function (p) {
            var img = p.image
              ? '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
              : '';
            return (
              '<a class="eos-quiz__result" href="' +
              p.url +
              '">' +
              img +
              '<span class="eos-quiz__result-title">' +
              p.title +
              '</span>' +
              '<span class="eos-quiz__result-price">' +
              p.price +
              '</span></a>'
            );
          })
          .join('');
      }
      steps.forEach(function (s) {
        s.classList.remove('is-active');
      });
      if (resultsEl) resultsEl.classList.add('is-active');
      setQuizLabel('eosQuizResultsTitle');
      var firstResult = qs('.eos-quiz__result', quiz);
      if (firstResult) firstResult.focus();
    }

    qsa('[data-eos-quiz-open]').forEach(function (btn) {
      btn.addEventListener('click', openQuiz);
    });
    qsa('[data-eos-quiz-close]', quiz).forEach(function (btn) {
      btn.addEventListener('click', closeQuiz);
    });
    var restartBtn = qs('[data-eos-quiz-restart]', quiz);
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        resetQuiz();
        var first = qs('.eos-quiz__step.is-active .eos-quiz__option', quiz);
        if (first) first.focus();
      });
    }
    qsa('.eos-quiz__step .eos-quiz__option', quiz).forEach(function (btn) {
      btn.addEventListener('click', function () {
        quizAnswers[quizStep] = btn.getAttribute('data-value');
        steps[quizStep].classList.remove('is-active');
        quizStep += 1;
        progressBars.forEach(function (b, j) {
          b.classList.toggle('done', j <= quizStep);
        });
        if (quizStep < 3) {
          steps[quizStep].classList.add('is-active');
          setQuizLabel('eosQuizTitle' + quizStep);
          var next = qs('.eos-quiz__option', steps[quizStep]);
          if (next) next.focus();
        } else {
          showQuizResults();
        }
      });
    });

    quiz.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeQuiz();
      } else if (e.key === 'Tab' && quiz.classList.contains('open')) {
        trapFocus(panel, e);
      }
    });
  }

  /* ---------------- Ask Eos Hour ---------------- */
  var askOpenBtn = qs('[data-eos-ask-open]');
  var askPanel = qs('[data-eos-ask-panel]');
  if (askOpenBtn && askPanel) {
    var askInput = qs('#eosAskInput');
    var askMessages = qs('[data-eos-ask-messages]');
    var askForm = qs('[data-eos-ask-form]');
    var askReturnFocus = null;
    var FAQ_FALLBACK =
      "I can only answer from what's on this site — but you can email us anytime at essentialpurchasesforyou@gmail.com and we'll reply within 24 hours.";
    var PUTTY_DESCRIPTION =
      'A soft cleaning putty for lifting dust, dirt and small particles from watch dials, cases and hard-to-reach areas. Gently press it onto suitable surfaces around watch faces, bezels and bracelet links. Please note: watches pictured are for display purposes only and are not included.';

    function askProduct() {
      var el = qs('script[data-eos-ask-product]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }
    function askAnswer(question) {
      var q = question.toLowerCase();
      var prod = askProduct();
      if (/watch(es)? (come|included)|included|case include/.test(q))
        return '"Please note: watches pictured are for display purposes only and are not included."';
      if (/quiz|case finder|recommend/.test(q))
        return '"Tell us the size of your collection, how you plan to use your case, and the finish you prefer. We\u2019ll narrow the collection for you."';
      if (/difference|compare|which (box|case)|choose/.test(q))
        return '"Verified details only. Choose by capacity, material and how you plan to use it."';
      if (/exchange/.test(q))
        return '"We do not offer direct exchanges at this time." "If you would like a different item, please return your original purchase (if eligible) and place a new order."';
      if (/cancel/.test(q))
        return '"Orders may be canceled only if they have not yet been processed or shipped." "Once an order has been shipped, it is no longer eligible for cancellation."';
      if (/shipping|deliver|track|return|refund/.test(q)) {
        var quotes = [];
        if (/track/.test(q))
          quotes.push(
            '"Once your order has shipped, you will receive a confirmation email containing tracking details." "Please allow 24\u201372 hours for tracking information to update after shipment."'
          );
        if (/shipping|deliver/.test(q))
          quotes.push(
            'Our Shipping Policy says: "All orders are processed within 1\u20133 business days after payment is successfully completed." Estimated delivery: "United States: 7\u201315 business days," "International: 10\u201325 business days." "Shipping costs are calculated at checkout and displayed before payment is completed."'
          );
        if (/return|refund/.test(q))
          quotes.push(
            'Our Return & Refund Policy says: "The return request must be submitted within 7 days of delivery." The item must be "unused, unworn, and in its original condition" and returned in its "original packaging." "Customers are responsible for return shipping costs, unless the item received was defective or incorrect."'
          );
        return quotes.join(' ');
      }
      if (/size|fit|dimension|slot|capacity/.test(q)) {
        if (prod && prod.specs && prod.specs.length) {
          var details = prod.specs.filter(function (s) {
            return /dimensions|slot count|quantity/i.test(s.label);
          });
          if (details.length)
            return details
              .map(function (s) {
                return '"' + s.label + ': ' + s.value + '"';
              })
              .join(' ');
        }
        return FAQ_FALLBACK;
      }
      if (/material|lining|made/.test(q) && prod && prod.specs && prod.specs.length) {
        var mats = prod.specs.filter(function (s) {
          return /^materials$/i.test(s.label);
        });
        if (mats.length) return '"Materials: ' + mats[0].value + '"';
      }
      if (/price|cost/.test(q) && prod && prod.variants && prod.variants.length) {
        var v = prod.variants[0];
        var sel = qs('[data-eos-variant-select]');
        if (sel && sel.selectedIndex >= 0 && prod.variants[sel.selectedIndex]) {
          v = prod.variants[sel.selectedIndex];
        }
        return '"' + v.title + ' \u2014 ' + money(v.price) + '"';
      }
      if (/clean|putty/.test(q)) return '"' + PUTTY_DESCRIPTION + '"';
      return FAQ_FALLBACK;
    }
    function toggleAsk(force) {
      var open = typeof force === 'boolean' ? force : askPanel.hasAttribute('hidden');
      if (open) {
        askReturnFocus = document.activeElement;
        askPanel.removeAttribute('hidden');
      } else {
        askPanel.setAttribute('hidden', '');
      }
      askOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && askInput) askInput.focus();
      else if (!open && askReturnFocus && document.contains(askReturnFocus)) askReturnFocus.focus();
    }
    function submitAsk(question) {
      var cleaned = (question || '').trim();
      if (!cleaned) return;
      var user = document.createElement('div');
      user.className = 'eos-ask-message user';
      user.textContent = cleaned;
      var answer = document.createElement('div');
      answer.className = 'eos-ask-message answer';
      answer.textContent = askAnswer(cleaned);
      askMessages.append(user, answer);
      askMessages.scrollTop = askMessages.scrollHeight;
      if (askInput) askInput.value = '';
    }

    askOpenBtn.addEventListener('click', function () {
      toggleAsk();
    });
    qsa('[data-eos-ask-close]', askPanel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleAsk(false);
      });
    });
    if (askForm) {
      askForm.addEventListener('submit', function (e) {
        e.preventDefault();
        submitAsk(askInput ? askInput.value : '');
      });
    }
    qsa('.eos-ask-chip', askPanel).forEach(function (chip) {
      chip.addEventListener('click', function () {
        submitAsk(chip.textContent);
      });
    });
    askPanel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        toggleAsk(false);
      } else if (e.key === 'Tab' && !askPanel.hasAttribute('hidden')) {
        trapFocus(askPanel, e);
      }
    });
  }

  /* ---------------- Lift Ask widget above the sticky buy bar ---------------- */
  var stickyBar = qs('[data-eos-sticky-buy]');
  if (stickyBar) {
    var updateLift = function () {
      document.body.classList.toggle('eos-ask-lift', !stickyBar.hasAttribute('hidden'));
    };
    if (window.MutationObserver) {
      new MutationObserver(updateLift).observe(stickyBar, { attributes: true, attributeFilter: ['hidden'] });
    }
    updateLift();
  }
})();
